import axios from "axios";

const SERVICE = "service-document-storage";
const ENTITY = "documents";

export default function () {
    return {
        async uploadFile(file) {
            try {
                const response = await axios.post(
                    process.env.REACT_APP_API_URL + `/${SERVICE}/uploader/${ENTITY}`,
                    file,
                    {headers: {"Content-Type": file.type || "application/octet-stream"}}
                );

                return response.data?.id ?? null;
            } catch (e) {
                console.log(e);
                return null;
            }
        }
    }
}
